export default [
  {
    image: "https://img.youtube.com/vi/NIhaEOfZoRM/maxresdefault.jpg",
    name: "Place to Visit Bomburu Ella Waterfall",
    route: "/pages/landing-pages/about-us",
  },
  {
    image: "https://img.youtube.com/vi/i91rWit-AT8/maxresdefault.jpg",
    name: "Year End Tour With University Friends",
    route: "/pages/landing-pages/contact-us",
  },
  {
    image: "https://img.youtube.com/vi/yhLfB7htzDU/maxresdefault.jpg",
    name: "Welcome To Sri Lanka | Sri Padaya [ Adam's Peak ]",
    route: "/pages/authentication/sign-in",
  },
  {
    image: "https://img.youtube.com/vi/urLb-wja7vk/maxresdefault.jpg",
    name: "Madu Ganga Boat Safari In 🇱🇰",
    route: "/pages/landing-pages/author",
  },
];
